/**
 * Date key format for availableDates is 'YYYY-M-D' (non-zero-padded).
 * Always read/write through normalizeAvailabilityKey() — never interpolate keys directly.
 */

export function normalizeAvailabilityKey(input: string | Date): string {
  const d =
    typeof input === 'string'
      ? input.includes('T') || input.includes(' ')
        ? new Date(input)
        : null
      : input
  if (d instanceof Date && !Number.isNaN(d.getTime())) {
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
  }
  const parts = (input as string).split('-')
  if (parts.length !== 3) throw new Error(`Invalid availability key: ${input}`)
  const [y, m, day] = parts
  return `${y}-${parseInt(m, 10)}-${parseInt(day, 10)}`
}

export function buildMonthKey(year: number, month: number): string {
  return `${year}-${month}` // month is 1-12, non-zero-padded
}
